import { Box, Grid, Typography } from "@mui/material";
import React, { memo } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import styles from "../../Rastreabilidade.module.css";

/**
 * Espelha o CompanyPresentation do campo: seção só da galeria, com o nome da
 * empresa no topo e o carrossel embaixo.
 *
 * Lá as imagens são baixadas e viram object URLs; aqui a API já entrega URLs
 * assinadas do S3, então elas vão direto para o carrossel.
 */
function ApresentacaoDistribuidora({ distribuidora }) {
	const galeria = distribuidora?.galeria ?? [];

	if (galeria.length === 0) return null;

	const itens = galeria.map((imagem) => ({
		original: imagem,
		thumbnail: imagem,
		originalHeight: "500px",
		originalWidth: "500px",
		fullscreen: imagem,
	}));

	return (
		<Box
			component="main"
			sx={{
				width: "100%",
				minHeight: "80vh",
				m: 0,
				p: 0,
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<Grid
				container
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					width: "100%",
					minHeight: "80vh",
				}}
			>
				<Grid
					size={12}
					sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
				>
					<Typography
						variant="h3"
						className={styles.titleTraceabilityProdut}
						sx={{ fontWeight: "800", color: "#009199", textAlign: "center" }}
					>
						{distribuidora?.nome}
					</Typography>
				</Grid>

				<Grid
					size={12}
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						mt: 6,
						// O carrossel tem largura própria; sem o teto ele estica junto
						// com a seção e as fotos ficam gigantes no desktop.
						"& .image-gallery": { maxWidth: "700px", width: "100%" },
					}}
				>
					<ImageGallery
						items={itens}
						showBullets
						showIndex
						showThumbnails
						showPlayButton
						showNav
						showFullscreenButton
						lazyLoad={false}
						thumbnailPosition="left"
					/>
				</Grid>
			</Grid>
		</Box>
	);
}

export default memo(ApresentacaoDistribuidora);
